import { Injectable, OnInit } from '@angular/core';
import { listResponseModel, permission, ResponseModel, SingleResponseModel, TabSystemMenuDto, UserFavouritePageMenuDto, userPermissionsDto } from '../../models/base/base';
import { BaseHttpService } from '../base/base-http.service';
import { HttpClient } from '@angular/common/http';
import { UserFavouritePageService } from '../global/user-favourite-page.service';
import { Navigation, NavigationItem } from 'src/app/@theme/types/navigation';
import { Observable, Subject, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { BaseService } from '../base/base.service';
import { Auth2Service } from '../Auth/auth2Service.service';
import { RTL } from 'src/app/@theme/const';
import { SessionWrapperService } from '../session/session-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class TabSystemMenuService extends BaseHttpService<TabSystemMenuDto> {

  private url = environment.baseUrl + this.getResourceUrl();
  favouriteTranslation = '';
  menusfromDB: NavigationItem[] = [];

  currentlang = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';
  menuCompleted = new Subject<boolean>();
  userPermissionsCompleted = new Subject<any[]>();
  private destroy: Subject<void> = new Subject<void>();


  constructor(private httpClient: HttpClient, private userFavouritePageService: UserFavouritePageService,
    private translate: TranslateService, private baseService: BaseService, private sessionService: SessionWrapperService,
    private auth2Service: Auth2Service, private themeLayout: ThemeLayoutService
  ) {
    super(httpClient);
    this.baseService.addRemoveFavourite.pipe(takeUntil(this.destroy)).subscribe((value: number) => {
      this.userFavouriteMenu();
    });
    // Session-based menu loading removed for now to fix compilation
    this.getMenuData();
    this.themeLayout.directionChange.pipe(takeUntil(this.destroy)).subscribe((dir) => {
      if (dir == RTL)
        this.currentlang = 'ar';
      else
        this.currentlang = 'en';
      this.getMenuData();
    });
  }

  getResourceUrl(): string {
    return 'TABSystemMenu';
  }

  getData(): Promise<any> {
    //
    // if (this.sessionService.getSysCode() != null) {
    //   let params = { 'SysCode': this.sessionService.getSysCode() };
    //   return this.httpClient.get(`${this.url}/Getalldatabyfilter`, { params: params }).toPromise();
    // }
    // else {
    //   return Promise.resolve(null) //handle null or undefined
    // }
    const userid = this.sessionService.getsessionData().userid;
    const syscode = this.sessionService.getSysCode();
    // return this.httpClient.get(`${this.url}/Getalldatabyfilter`, { params: params }).toPromise();
    return this.httpClient.get<listResponseModel<TabSystemMenuDto>>(`${this.url}/GetUserSysMenuPermission?userid=${userid}&syscode=${syscode}`).toPromise();
  }

  getMenuData() {
    //let params = { NotActive: false }
    //
    this.getData()?.then((res: listResponseModel<TabSystemMenuDto>) => {
      if (res) {
        if (res.result) {
          let menuItem: Navigation;
          if (res.result.length > 0) {
            this.favouriteTranslation = this.translate.instant('favourite');
            this.menusfromDB = [
              {
                id: 'navigation',
                title: '',
                type: 'group',
                icon: 'icon-navigation',
                children: [
                  {
                    id: 'Favourite',
                    title: this.favouriteTranslation,
                    type: 'collapse',
                    icon: '#custom-star-bold',
                    children: [
                    ]
                  }
                ]
              }
            ];

            res.result.filter(x => x.parentid == null || x.parentid == "00000000-0000-0000-0000-000000000000" && !this.checkifParent(res.result, x.id)).forEach((page: TabSystemMenuDto) => {

              menuItem = {
                id: page.id,
                title: (this.currentlang == 'ar' ? page.menuaraname : page.menulatname),
                type: 'item',
                url: page.pageurl + '/' + page.id,
                sort: page.sort
              };

              this.menusfromDB.find(x => x.id = 'navigation').children?.push(menuItem);

            });

            res.result.filter(x => x.parentid == "00000000-0000-0000-0000-000000000000" && this.checkifParent(res.result, x.id)).forEach((page: TabSystemMenuDto) => {

              menuItem = {
                id: page.id,
                title: (this.currentlang == 'ar' ? page.menuaraname : page.menulatname),
                type: 'collapse',
                url: page.pageurl,
                sort: page.sort,
                children: []
              };

              this.menusfromDB.find(x => x.id = 'navigation').children.push(menuItem);

            });

            res.result.filter(x => x.parentid != null && x.parentid != "00000000-0000-0000-0000-000000000000" && this.checkifParent(res.result, x.id)).forEach((page: TabSystemMenuDto) => {

              menuItem = {
                id: page.id,
                title: (this.currentlang == 'ar' ? page.menuaraname : page.menulatname),
                type: 'collapse',
                url: page.pageurl,
                sort: page.sort,
                children: []
              };

              this.menusfromDB.find(x => x.id = 'navigation').children.find(x => x.id == page.parentid)?.children?.push(menuItem);

            });

            res.result.filter(x => x.parentid != null && x.parentid != "00000000-0000-0000-0000-000000000000" && !this.checkifParent(res.result, x.id)).forEach((page: TabSystemMenuDto) => {

              menuItem = {
                id: page.id,
                title: (this.currentlang == 'ar' ? page.menuaraname : page.menulatname),
                type: 'item',
                url: page.pageurl + '/' + page.id,
                sort: page.sort
              };

              if (this.menusfromDB.find(x => x.id = 'navigation').children.find(x => x.id == page.parentid)) {
                this.menusfromDB.find(x => x.id = 'navigation').children.find(x => x.id == page.parentid)?.children?.push(menuItem);
              }
              else {
                this.menusfromDB.find(x => x.id = 'navigation').children.find(x => x.id == this.getParentId(res.result, page.parentid))?.children?.find(x => x.id == page.parentid).children?.push(menuItem);
              }

            });
            this.userFavouriteMenu();
            console.log('this.menusfromDB', this.menusfromDB);
            this.menuCompleted.next(true);
          }

        }
      }
    }).catch(err => {
      console.log('menu err', err);
      this.menuCompleted.next(false);
    });
  }

  checkifParent(items: any[], id) {
    let isParent: boolean = false;
    isParent = items.filter(x => x.parentid == id)?.length > 0 ? true : false;
    return isParent;
  }

  getParentId(items: any[], id, fieldname = null) {
    let item;
    if (fieldname == null)
      item = items.find(x => x.id == id);
    else
      item = items.find(x => x[fieldname] == id);
    return item?.parentid;
  }

  userFavouriteMenu() {
    let userFavPages: Navigation[] = [];
    this.userFavouritePageService.getUserFavouritePagesWithMenu()?.pipe(takeUntil(this.destroy)).subscribe((res) => {
      if (res) {
        if (res.result) {
          if (res.result.length > 0) {
            let pages = res.result?.filter(x => x['syscode'] == this.sessionService.getSysCode());
            pages.forEach((page: UserFavouritePageMenuDto) => {
              userFavPages.push({
                id: page.id,
                title: (this.currentlang == 'ar' ? page.menuaraname : page.menulatname),
                type: 'item',
                url: page.pageurl + '/' + page.tabsystemmenuid
              });

            });
          }

          this.menusfromDB.find(x => x.id = 'navigation').children.find(x => x.id == 'Favourite').children = userFavPages;

        }
      }
    });

  }

  //https://host.tabmshr.com/api/v1/TABSystemMenu/GetUserPagesPermission?userid=a6b47cd4-5537-11fc-f14d-3a12b2610fbe
  getUserPagesPermission(userid) {
    let params = { 'userid': userid };
    return this.httpClient.get(`${this.url}/GetUserPagesPermission`, { params: params });
  }

  getUserPermissionsData(userid) {
    let usersPermissions: permission[] = [];
    this.getUserPagesPermission(userid)?.pipe(takeUntil(this.destroy)).subscribe((res: listResponseModel<userPermissionsDto>) => {

      if (res) {
        let permissionData = res?.result;
        if (permissionData) {
          let menuItem: permission;
          if (permissionData.length > 0) {
            //this.userPermissionsCompleted.next(permissionData);

            // let oldObject = [
            //   {
            //     name: 'user-administration',
            //     children: [
            //       { name: 'users', count: 10 },
            //       { name: 'user-permissions', count: 20 },
            //       { name: 'role-permissions', count: 30 },
            //     ]
            //   }, {
            //     name: 'hr',
            //     children: [
            //       {
            //         name: 'main-settings',
            //         children: [
            //           { name: 'banks', count: 10 },
            //           { name: 'departments', count: 20 },
            //           { name: 'company', count: 30 },
            //         ]
            //       }, {
            //         name: 'attendance',
            //         children: [
            //           { name: 'attendance-settings', count: 30 },
            //           { name: 'attendance-transactions', count: 40 },
            //           { name: 'attendance-reports', count: 40 },
            //         ]
            //       },
            //     ]
            //   },
            // ];

            permissionData.filter(x => x.parentid == null || x.parentid == "00000000-0000-0000-0000-000000000000" && !this.checkifParent(permissionData, x.menuid)).forEach((page: userPermissionsDto) => {

              menuItem = {
                menuid: page.menuid,
                name: (this.currentlang == 'ar' ? page.menuaraname : page.menulatname),
                tabpermissiontypecode: page.tabpermissiontypecode,
                access: page.access,
                insert: page.insert,
                edit: page.edit,
                delete: page.delete,
                print: page.print,
                export: page.export,
                notactive: page.notactive
              };

              usersPermissions.push(menuItem);

            });

            permissionData.filter(x => x.parentid == null || x.parentid == "00000000-0000-0000-0000-000000000000" && this.checkifParent(permissionData, x.menuid)).forEach((page: userPermissionsDto) => {

              menuItem = {
                menuid: page.menuid,
                name: (this.currentlang == 'ar' ? page.menuaraname : page.menulatname),
                tabpermissiontypecode: page.tabpermissiontypecode,
                access: page.access,
                insert: page.insert,
                edit: page.edit,
                delete: page.delete,
                print: page.print,
                export: page.export,
                notactive: page.notactive,
                children: []
              };

              usersPermissions.push(menuItem);

            });

            permissionData.filter(x => x.parentid != null && x.parentid != "00000000-0000-0000-0000-000000000000" && this.checkifParent(permissionData, x.menuid)).forEach((page: userPermissionsDto) => {

              menuItem = {
                menuid: page.menuid,
                name: (this.currentlang == 'ar' ? page.menuaraname : page.menulatname),
                tabpermissiontypecode: page.tabpermissiontypecode,
                access: page.access,
                insert: page.insert,
                edit: page.edit,
                delete: page.delete,
                print: page.print,
                export: page.export,
                notactive: page.notactive,
                children: []
              };

              usersPermissions.find(x => x.menuid == page.parentid)?.children?.push(menuItem);

            });

            permissionData.filter(x => x.parentid != null && x.parentid != "00000000-0000-0000-0000-000000000000" && !this.checkifParent(permissionData, x.menuid)).forEach((page: userPermissionsDto) => {

              menuItem = {
                menuid: page.menuid,
                name: (this.currentlang == 'ar' ? page.menuaraname : page.menulatname),
                tabpermissiontypecode: page.tabpermissiontypecode,
                access: page.access,
                insert: page.insert,
                edit: page.edit,
                delete: page.delete,
                print: page.print,
                export: page.export,
                notactive: page.notactive
              };

              if (usersPermissions.find(x => x.menuid == page.parentid)) {
                usersPermissions.find(x => x.menuid == page.parentid)?.children?.push(menuItem);
              }
              else {
                usersPermissions.find(x => x.menuid == this.getParentId(permissionData, page.parentid, 'menuid'))?.children?.find(x => x.menuid == page.parentid).children?.push(menuItem);
              }

            });

          }

        }
      }
      console.log('usersPermissions', usersPermissions);
      // console.log('oldObject', oldObject);
      this.userPermissionsCompleted.next(usersPermissions);
    });
  }


  get(id: any): Observable<SingleResponseModel<TabSystemMenuDto>> {
    let params = { id: id };
    return this.httpClient.get<SingleResponseModel<TabSystemMenuDto>>(`${this.baseUrl}/Getbyid`, { params: params });
  }

  getById(id: string): Observable<SingleResponseModel<TabSystemMenuDto>> {
    let params = { 'id': id };
    return this.httpClient.get<SingleResponseModel<TabSystemMenuDto>>(`${this.baseUrl}/Getbyid`, { params: params });
  }

  getPermissionTypes(): Observable<any> {
    return this.httpClient.get(`${environment.baseUrl}/TABPermisionTypes/GetAllData`);
  }
  findPageAndSystem(menuKey: string,pageparameters?:string): ResponseModel<TabSystemMenuDto> | Observable<ResponseModel<TabSystemMenuDto>> | any {
    const params:any = { pagemenukey: menuKey  };
    if (pageparameters) {
    params.pageparameters = pageparameters;
  }
    return this.httpClient.get<ResponseModel<TabSystemMenuDto>>(`${this.url}/Getalldatabyfilter`, { params });
  }
  //region destory subscribtion
  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }
  //end region
}
